<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon
      :disabled="this.getDetailChar.stat || this.disableResultEdit">
        <v-icon :color="ui.btnColor"> create </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(this.engResults.basic.idi)}} Technical Result
            <v-spacer/>
            {{displayDocumentIDGTypeA(this.engResults.basic.tag, this.engResults.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Inspection and Test Requirements
                </div>
                <v-spacer/>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="localForm.title"
                  label="result name"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.type"
                  :items="resultsTypeOptions"
                  label="type"
                  prepend-icon="grid_view"
                  hint="result type"
                  required>
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.id"
                  label="result id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="fingerprint"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.dis"
                  :items="engineeringDiscipline"
                  label="discipline"
                  prepend-icon="engineering"
                  hint="discipline"
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.own"
                  :items="resultsOwnerOptions"
                  hint="own"
                  prepend-icon="person"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.cat"
                  :items="resultsCategoryOptions"
                  prepend-icon="settings"
                  hint="category"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.ref"
                  :rules="mustBeLessThanSmallNotRequired"
                  prepend-icon="radio_button_unchecked"
                  hint="reference"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.method"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="adjust"
                  hint="method"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.spec"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="science"
                  hint="specification"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-2 mt-4 mb-2">
                  Inspection and Test Criteria
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.cond"
                  :items="conditionForActivityOptions"
                  prepend-icon="build_circle"
                  hint="condition"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.test"
                  :items="resultTestOptions"
                  prepend-icon="bubble_chart"
                  label="outcome"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.unit"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="straighten"
                  label="unit"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div v-if="localForm.test === 'Number'">
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm4 offset-sm4>
                    <v-text-field
                    v-model="localForm.rhi1"
                    :rules="mustBeNumberNegOrPos"
                    prepend-icon="warning"
                    label="high warning"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                    v-model="localForm.rhi2"
                    :rules="mustBeNumberNegOrPos"
                    prepend-icon="error"
                    label="high fault"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm4 offset-sm4>
                    <v-text-field
                    v-model="localForm.rlo1"
                    prepend-icon="warning"
                    :rules="mustBeNumberNegOrPos"
                    label="low warning"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                    v-model="localForm.rlo2"
                    :rules="mustBeNumberNegOrPos"
                    prepend-icon="error"
                    label="low fault"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm4 offset-sm4>
                    <v-text-field
                    v-model="localForm.rin1"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="warning"
                    label="warning criteria"
                    required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                    v-model="localForm.rin2"
                    :rules="ruleMustBeFilledANDLessThan50"
                    prepend-icon="error"
                    label="fault criteria"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <InfoDateAgoName :data="this.engResults.stats"/>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  hint="technical results description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="deleteResults()" color="error" flat
              class="hidden-xs-only"
              v-if="this.localForm.status !== 'Order'"
              :disabled="this.getResultsList.length < 1">
              <v-icon left> delete </v-icon>
                Delete
            </v-btn>
            <v-btn @click="deleteResults()" color="error" flat
              class="hidden-sm-and-up"
              v-if="this.localForm.status !== 'Order'"
              :disabled="this.getResultsList.length < 1">
              <v-icon> delete </v-icon>
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> create </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import linkFunctions from "@/data/functions/mixins/linkFunctions.js";
import resultsOptions from "@/data/options/mixins/resultsOptions.js";
import executionOptions from "@/data/options/mixins/executionOptions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    master,
    techOptions,
    rulesTextfield,
    resultsOptions,
    dateFunctions,
    listFunctions,
    linkFunctions,
    uisettings,
    docRevsModFunctions,
    numberFunctions,
    financeFunctions,
    executionOptions,
    displayFunctions,
    apptheme
  ],
  components: {
    InfoDateAgoName
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetailChar",
      "getDetail",
      "getCurrentPage",
      "getResultsList",
      "getUser",
      "getResultsListCounter"
    ]),
    reactiveResultsList() {
      return this.getResultsList;
    },
    disableResultEdit() {
      let logic = null;
      if (this.getCurrentPage === "/workrequestdetail") {
        let flow = this.getDetail.trans.flow;
        let transStatus = flow[flow.length - 1].title;
        if (transStatus === "Closed" || transStatus === "Cancelled") {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }
      return logic;
    }
  },
  props: {
    engResults: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localForm: {
        id: "", // parts Id
        title: "", // parts title
        type: "", // typ
        dis: "", // discipline
        com: "", // comment
        own: "", // who is doing it
        method: "", // method
        ref: "", // standard
        cond: "", // condition
        spec: "",
        pass: "",
        result: "",
        test: "",
        unit: "",
        rin1: "",
        rin2: "",
        rhi1: "",
        rhi2: "",
        rlo1: "",
        rlo2: ""
      }
    };
  },
  beforeMount() {
    this.localForm.title = this.engResults.basic.title;
    this.localForm.id = this.engResults.basic.id;
    this.localForm.com = this.engResults.char.com;
    this.localForm.cond = this.engResults.char.cond;
    this.localForm.cat = this.engResults.char.cat;
    this.localForm.spec = this.engResults.char.spec;
    this.localForm.result = this.engResults.char.result;
    this.localForm.pass = this.engResults.char.pass;
    this.localForm.ref = this.engResults.char.ref;
    this.localForm.own = this.engResults.char.own;
    this.localForm.method = this.engResults.char.method;
    this.localForm.dis = this.engResults.char.dis;
    this.localForm.type = this.engResults.char.type;
    this.localForm.ref = this.engResults.char.ref;
    this.localForm.test = this.engResults.char.test;
    this.localForm.unit = this.engResults.char.unit;
    this.localForm.rhi1 = this.engResults.char.rhi1;
    this.localForm.rhi2 = this.engResults.char.rhi2;
    this.localForm.rlo1 = this.engResults.char.rlo1;
    this.localForm.rlo2 = this.engResults.char.rlo2;
    this.localForm.rin1 = this.engResults.char.rin1;
    this.localForm.rin2 = this.engResults.char.rin2;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    refreshList() {
      let store = "changeResultsListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getResultsListCounter + 1);
      this.$store.dispatch(store, this.getResultsListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // engResults removed.
    },
    deleteResults() {
      // LIST UPDATE
      let tempList = this.getResultsList;
      let newList = this.deleteItemReturnList(this.engResults, tempList);
      this.$store.dispatch("changeResultsList", newList);
      this.refreshList();

      // RESET DETAIL LINK
      this.resetLinkAppendedProgram();

      // CLOSE
      this.dialog = false;
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // hi
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // add dates
        let tempForm = this.engResults;

        // BASIC
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;

        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.dis = this.localForm.dis;
        tempForm.char.method = this.localForm.method;
        tempForm.char.cond = this.localForm.cond;
        tempForm.char.cat = this.localForm.cat;
        tempForm.char.own = this.localForm.own;
        tempForm.char.pass = this.localForm.pass;
        tempForm.char.com = this.localForm.com;
        tempForm.char.ref = this.localForm.ref;
        tempForm.char.spec = this.localForm.spec;
        tempForm.char.status = "C";
        tempForm.char.test = this.localForm.test;
        tempForm.char.unit = this.localForm.unit;
        tempForm.char.rhi1 = this.localForm.rhi1;
        tempForm.char.rhi2 = this.localForm.rhi2;
        tempForm.char.rlo1 = this.localForm.rlo1;
        tempForm.char.rlo2 = this.localForm.rlo2;
        tempForm.char.rin1 = this.localForm.rin1;
        tempForm.char.rin2 = this.localForm.rin2;

        // STATS
        tempForm.stats.date = moment().format();
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getResultsList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.changeItemReturnList(parseobj, tempList);
        this.$store.dispatch("changeResultsList", newList);
        this.refreshList();

        // RESET DETAIL LINK
        this.resetLinkAppendedProgram();

        // CLOSE
        this.dialog = false;
      }
    }
  }
};
</script>
